import axios from 'axios'
import { setToken, getToken, clearToken } from '@/api/libs/util'
import { setCookie, getCookie, contanisCookie, removeCookie } from '@/api/libs/cookie'
import {Message} from 'element-ui';

// import { Message } from "view-design";
// import { Spin } from 'iview'
const addErrorLog = errorInfo => {
  const {
    statusText,
    status,
    request: {
      responseURL
    }
  } = errorInfo
  let info = {
    type: 'ajax',
    code: status,
    mes: statusText,
    url: responseURL
  }
  // if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
}

// 可以通过请求的列表
const normalUrls = [
  '/editor-of-charge-manuscript/findManuscriptByChargeEmail',
  '/editor-of-chief-manuscript/findAuditOpinionById',
  '/editor-of-chief-manuscript/findManuscriptByChiefEmail',
  '/reviewer-manuscript/editorDetail',
  '/reviewer-manuscript/editorList',
  '/reviewer-manuscript/findManuscriptByReviewerEmail',
  '/contributor-manuscript/getManuscriptsContributorInfo',
  '/contributor-manuscript/findManuscriptByContributorEmail',
  '/user/roleList',
  '/manuscript/recommendAndAvoidRewiewer',

  '/manuscripts/addManuscripts',
  '/editor-of-charge-manuscript/getManuscriptsChargeInfo',
  '/editor-of-charge-manuscript/forwardManuscript',
  '/reviewer-manuscript/getManuscriptsReviewerInfo',
  '/reviewer-manuscript/addAuditOpinion',
  '/editor-of-chief-manuscript/getManuscriptsChiefInfo',
  '/editor-of-chief-manuscript/chiefAddAuditOpinion',
  '/manuscripts/manuscriptsList',
  '/manuscripts/sameManuscriptInfo',
  '/manuscripts/getVersion',
  '/user/register',
  '/user/login',
  '/manuscripts/homePageManuscriptsList',
  '/manuscripts/manuscriptLibrary',
  '/manuscripts/tsAuthorInfo',
  '/manuscripts/tsReviewersInfo',
  '/manuscripts/tsFileInfo',
  '/manuscripts/tsManuscriptInfo',

  '/manuscripts/getTsAuthorInfo',
  '/manuscripts/getTsReviewersInfo',
  '/manuscripts/getTsFileInfo',
  '/manuscripts/getTsManuscriptInfo',

  '/manuscripts/findManuscriptsById',
  '/user/updatePassword',
  '/user/waitForReview',
  '/user/audit',
  '/manuscripts/exportFile',
  '/matchByYear',
  '/view-statistics/add',
  '/view-statistics/show',
  '/reviewer-manuscript/reviewerCancelTheAudit',
  '/contributor-manuscript/cancelTheDelivery',
  '/editor-of-charge-manuscript/editorCancelTheAudit',
  '/manuscripts/fuzzySearch',
  '/manuscript/file/download',
  '/manuscript/file/num',
  '/manuscript/file/downloadPdf'
]

class HttpRequest {
  constructor (baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        //
      },
      withCredentials: true
    }
    return config
  }
  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {

    }
  }
  interceptors (instance, url) {
    // 请求拦截
    let normalRequest = normalUrls.indexOf(url) > 0
    if (!normalRequest && !contanisCookie('authority')) {
      console.log(url)
      // Message("无权限")
      // return Promise.reject("无权限")
    }
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      this.queue[url] = true

      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)

      const {
        data,
        status
      } = res
      if (!normalRequest) {
        if (data.errorCode != 401) {
          let authority = getCookie('authority')
          let userInfo = getCookie('userInfo')
          removeCookie('authority')
          removeCookie('userInfo')
          setCookie('authority', authority, 60)
          setCookie('userInfo', userInfo, 60)
        } else {
          removeCookie('authority')
          removeCookie('userInfo')
        }
      }
      // if (data.errorCode != 0) {
      //   Message.error(data.errorMessage)
      // }
      return {
        data,
        status
      }
    }, error => {
      this.destroy(url)
      let errorInfo = error.response
      if (!errorInfo) {
        const {
          request: {
            statusText,
            status
          },
          config
        } = JSON.parse(JSON.stringify(error))
        errorInfo = {
          statusText,
          status,
          request: {
            responseURL: config.url
          }
        }
      }
      addErrorLog(errorInfo)
      return Promise.reject(error)
    })
  }
  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest



// WEBPACK FOOTER //
// ./src/api/libs/axios.js